import { CommonListing } from '@listings/models/listing/common-listing';

export class Listings {
    [key: string]: CommonListing;
}